<template>
    <BaseSimpleModal :title="$t('request_integration.btn')" :subtitle="$t('request_integration.description')"
        :showHeader="true" @close="$emit('close')" @backdropClick="$emit('close')" :fullHeight="false" fitContent
        showClose>

        <div class="content">
            <BaseTextInput :placeholder="$t('request_integration.name_ph')" v-model="name" size="md" />
        </div>

        <template #footer>
            <BasePushButton @click="submit" :disabled="!name || name.length < 3" variant="fill" icon="plus" size="md"
                class="w-100" bgColor="background-success-default" textColor="content-base-inverse-primary">
                {{ $t("request_integration.btn") }}
            </BasePushButton>
        </template>
    </BaseSimpleModal>
</template>

<script>
import IntegrationsAPI from '@/api/integrations'

export default {
    data () {
        return {
            name: ''
        }
    },
    methods: {
        submit () {
            IntegrationsAPI.requestIntegration(this.$store.state.cafe._id, this.name)
                .then(() => {
                    this.$emit('close')
                    this.$store.commit("ui/addToast", {
                        variant: "confirm",
                        content: this.$t("request_integration.success"),
                    });
                })
                .catch(() => {
                    this.$emit('close')
                    this.$store.commit("ui/addToast", {
                        variant: "error",
                        content: ":("
                    });
                })
        }
    },
    components: {

    }
}
</script>

<style scoped>
.content {
    padding: 16px 20px;
}
</style>